export { default } from './Footer';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Footer/index.js